import { Typography, useTheme } from '@mui/material';

import { BREAKPOINTS } from '@tbd/life-tokens';

export const QuestionText = ({
  text,
  type,
}: {
  text: string;
  type: 'info' | 'question';
}) => {
  const theme = useTheme();
  const fontWeight = type === 'info' ? 'regular' : 'bold';

  return (
    <Typography
      sx={{
        display: 'inline',
        ...theme.typography[`component-${fontWeight}-s`],
        [BREAKPOINTS.MEDIUM]: {
          ...theme.typography[`component-${fontWeight}-m`],
        },
      }}
    >
      {text}
    </Typography>
  );
};
